import { Controller } from "@hotwired/stimulus";

/**
 * Deletes HTML-element after time interval specified in "timeout" value
 *
 * Usage:
 *   1. Define HTML-element you want to delete (data-controller="remove-element");
 *   2. Set "timeout" value in seconds after which element will be deleted (data-remove-element-timeout-value="30").
 *
 * Example:
 *   <div data-controller="remove-element" data-remove-element-timeout-value="30">...</div>
 */

// Connects to data-controller="remove-element"
export default class extends Controller {
  static values = {
    timeout: Number,
  };

  connect() {
    setTimeout(() => {
      this.element.remove();
    }, this.timeoutValue * 1000);
  }
}
